
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","viewBox":"0 0 10 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 .757v8.486M9.243 5H.757","stroke":"#593289","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    